<nav class="navbar navbar-main flex-row justify-content-between">
    @if (!commonDataService.user.isSystemAdmin) {
        @if (isLeftSidebarVisible()) {
            <div class="sidebar-toggler" data-testid="inbox-ui-left-sidebar-toggle" (click)="toggleSidebar()">
                <div
                    class="add-arrow"
                    [ngClass]="{
                        'add-arrow-left': sideNavigationService.isLeftMenuOpen,
                        'add-arrow-right': !sideNavigationService.isLeftMenuOpen,
                    }"></div>
            </div>
        }

        @if (isTopBarVisible('searchField')) {
            <form class="my-2 my-lg-0 flex-fill me-4" data-testid="inbox-ui-search-section">
                @if (!commonDataService.user.isReadOnly) {
                    <div class="form-control form-control-search d-flex flex-row align-items-center">
                        <input
                            id="search-bar"
                            class="flex-fill"
                            type="search"
                            placeholder="{{ 'Search' | translate }}"
                            aria-label="Search"
                            name="search"
                            autocomplete="off"
                            maxlength="100"
                            [(ngModel)]="commonDataService.searchQuery"
                            (ngModelChange)="this.searchQueryUpdate.next($event)" />
                        @if (commonDataService.searchQuery) {
                            <span class="btn-transparent btn-clear" (click)="cleanSearch()">
                                <sb-inline-svg
                                    class="icon icon-clear"
                                    aria-label="My icon"
                                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                                </sb-inline-svg>
                            </span>
                        }
                        <button type="button" class="btn btn-default" (click)="openAdvancedSearchModal()" translate>
                            Advanced search
                        </button>
                    </div>
                }
            </form>
        } @else {
            <div class="flex-fill"></div>
        }
        @if (isTopBarVisible('notificationBell')) {
            <app-notifications-dropdown
                class="me-5"
                data-testid="inbox-ui-notification-bell"></app-notifications-dropdown>
        }
    }
    <div class="ms-auto">
        <sb-settings-menu
            [user]="commonDataService.user"
            [customerSettings]="commonDataService.customerSettings"
            [communityName]="commonDataService.community"
            [language]="commonDataService.language"
            (logout)="authenticationService.logOff({ isNeedToRevokeToken: true })">
        </sb-settings-menu>
    </div>
</nav>
